import { ErrorModel, LockModel, RootState, StoreConstants } from '@/types';
import { ListMaintenanceState } from '@/types/store/configuration/listMaintenance';
import { GetterTree } from 'vuex';

export const getters: GetterTree<ListMaintenanceState, RootState> = {
  [StoreConstants.ListMaintenance.Getters.EntityLock](state): LockModel {
    return state.builtInListLock;
  },
  [StoreConstants.ListMaintenance.Getters.ExtendingLock](state): boolean {
    return state.extendingLock;
  },
  [StoreConstants.ListMaintenance.Getters.Error](state): ErrorModel {
    return state.errorModel;
  }
};
